export default __webpack_public_path__ + "static/media/logo.cf0ce0b6.png";